/**
 * @param form {HTMLFormElement}
 * @returns {any}
 */
module.exports = function getFormDataAsObject(form) {
    const formData = new FormData(form);

    /**
     * @type {{object}}
     */
    const formDataObject = {};

    for (let [key, value] of formData) {
        formDataObject[key] = value;
    }

    return formDataObject;
};
